import type { TransitionsReqV2 } from '@revelio/data-access';

/**
 * The transitions API requires every entity in a request to share one
 * `EntType`. Drop any entity whose type differs from the first — the
 * transition map then aggregates flows across the remaining (same-type)
 * entities.
 */
export const filterEntitiesToFirstEntType = (
  req: TransitionsReqV2
): TransitionsReqV2 => {
  if (req.entities.length <= 1) return req;
  const firstType = req.entities[0]?.EntType;
  if (!firstType) return req;

  return {
    ...req,
    entities: req.entities.filter((e) => e.EntType === firstType),
  };
};

/**
 * The Sankey transition chart renders flows for a single entity. Narrow the
 * request to its first entity.
 */
export const keepFirstTransitionEntity = (
  req: TransitionsReqV2
): TransitionsReqV2 => {
  const [first] = req.entities;
  if (!first || req.entities.length === 1) return req;

  return { ...req, entities: [first] };
};
